import React, { Component, createRef } from "react";

// Each pair of corners sharing a side sums to 100% for a smooth blob
function randomBlob(min = 30, max = 70) {
  const r = () => Math.round(Math.random() * (max - min) + min);
  const tlH = r(),
    trH = 100 - tlH;
  const brH = r(),
    blH = 100 - brH;
  const tlV = r(),
    blV = 100 - tlV;
  const trV = r(),
    brV = 100 - trV;
  return `${tlH}% ${trH}% ${brH}% ${blH}% / ${tlV}% ${trV}% ${brV}% ${blV}%`;
}

class CaseStudyPreviewHz extends Component {
  imgRef = createRef();
  morphAnimation = null;

  handleMouseEnter = () => {
    const el = this.imgRef.current;
    if (!el) return;

    // Clear any in-progress exit transition
    el.style.transition = "";
    el.style.borderRadius = "";

    const keyframes = [
      { borderRadius: "50px" },
      { borderRadius: randomBlob() },
      { borderRadius: randomBlob() },
      { borderRadius: randomBlob() },
      { borderRadius: randomBlob() },
      { borderRadius: "50px" },
    ];

    this.morphAnimation = el.animate(keyframes, {
      duration: 12000,
      easing: "ease-in-out",
      iterations: Infinity,
    });
  };

  handleMouseLeave = () => {
    const el = this.imgRef.current;
    if (!el) return;

    // Snapshot the current blob shape before cancelling
    const currentRadius = window.getComputedStyle(el).borderRadius;

    if (this.morphAnimation) {
      this.morphAnimation.cancel();
      this.morphAnimation = null;
    }

    el.style.borderRadius = currentRadius;

    // Double RAF ensures the frozen shape is painted before the transition starts
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition = "border-radius 1.2s ease-in-out";
        el.style.borderRadius = "50px";
      });
    });
  };

  render() {
    const {
      caseStudyURL,
      thumbimg,
      companyname,
      title,
      desc,
      comingSoon = false,
    } = this.props;

    const Wrapper = comingSoon ? "div" : "a";

    return (
      <Wrapper
        {...(!comingSoon ? { href: caseStudyURL } : {})}
        className="case-study-url"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="case-study-preview-hz">
          <div className="row">
            <div
              ref={this.imgRef}
              className="col-md-7 case-study-preview-hz-img"
              style={{ backgroundImage: `url(${thumbimg})` }}
            ></div>
            <div className="col-md-5 content">
              <span className="chip">{companyname}</span>
              <h3 className="m-0">{title}</h3>
              <p>{desc}</p>
              <p>
                {comingSoon ? (
                  <button className="btn-default disabled">Coming Soon</button>
                ) : (
                  <button className="btn-default">View Case Study</button>
                )}
              </p>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default CaseStudyPreviewHz;
